// extracted by mini-css-extract-plugin
export default {"controls":"PageControls_controls__Fle4M","addButton":"PageControls_addButton__s7fR4","title":"PageControls_title__Za8Ga"};